module.exports = __webpack_public_path__ + "home-hero-3wJcklN.png";